module.exports = __webpack_public_path__ + "static/img/grade-bg.aeeacb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/grade-bg.png
// module id = wdmm
// module chunks = 1